import appStorePngImage from "assets/images/appstore.png";
import appStoreSvgImage from "assets/images/appstore.svg";
import googlePlayPngImage from "assets/images/googleplay.png";
import googlePlaySvgImage from "assets/images/googleplay.svg";
import webAppImage from "assets/images/webapp.png";
import { config } from "constant";
import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";
import Image from "./Image";
import Link from "./Link";

type StoreBadgeVariant = "png" | "svg";

type Props = ComponentProps<"div"> & {
  badgeVariant?: StoreBadgeVariant;
};

const storeBadges = {
  png: {
    appStore: appStorePngImage,
    googlePlay: googlePlayPngImage,
  },
  svg: {
    appStore: appStoreSvgImage,
    googlePlay: googlePlaySvgImage,
  },
};

export default function AppCtaButtons({
  badgeVariant = "png",
  className,
  ...props
}: Props) {
  const badges = storeBadges[badgeVariant];

  return (
    <div className={twMerge("app-cta-buttons", className)} {...props}>
      <Link
        href={config.appStoreUrl}
        aria-label="Download LinksRoom on the App Store"
        className="app-cta-link"
      >
        <Image
          src={badges.appStore}
          alt="Download on the App Store"
          className="app-cta-badge"
        />
      </Link>
      <Link
        href={config.googlePlayUrl}
        aria-label="Get LinksRoom on Google Play"
        className="app-cta-link"
      >
        <Image
          src={badges.googlePlay}
          alt="Get it on Google Play"
          className="app-cta-badge"
        />
      </Link>
      <Link
        href={config.webAppUrl}
        aria-label="Login with LinksRoom web app"
        className="app-cta-link"
      >
        <Image
          src={webAppImage}
          alt="Continue with Web App"
          className="app-cta-badge"
        />
      </Link>
    </div>
  );
}
